module.exports = __webpack_public_path__ + "img/SVG11_Occupation.04150483.svg";